import script from "./nextdayTreasureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./nextdayTreasureView.vue?vue&type=script&setup=true&lang=ts"

import "./nextdayTreasureView.vue?vue&type=style&index=0&id=e282ea02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e282ea02"]])

export default __exports__